import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';

// components
import { SbSharedLink } from '../SbSharedLink/SbSharedLink';
import { SbSharedCategoryTilesTracking } from '../SbSharedCategoryTilesTracking/SbSharedCategoryTilesTracking';
import { SbRespTilesSwiper } from '../SbRespTilesSwiper/SbRespTilesSwiper';
import { ServerVarsContextConsumer } from '../../global/ServerVarsContext/ServerVarsContext';

// styles
import styles from './sbRespCategoryTiles.scss';

export const SbRespCategoryTilesComponent = props => {
    const { searchBrowse } = props;

    if (!get(searchBrowse, 'categoryTiles.length')) {
        return null;
    }

    /**
     * We show 5 tiles max.
     *
     * Special case - for fashion we only show 4, but that is already handled in graphql, so we
     * don't need to handle it here.
     *
     */
    const tiles = searchBrowse.categoryTiles.slice(0, 5);

    return (
        <ServerVarsContextConsumer>
            {({ isTablet }) => {
                const containerClass = classnames(styles.container, {
                    rowFlex: !isTablet,
                });
                return (
                    <SbSharedCategoryTilesTracking searchBrowse={searchBrowse} maxTilesAllowed={5}>
                        {({ trackClick }) => (
                            <div className={`${containerClass}`} data-tn="category-tiles">
                                <SbRespTilesSwiper isTablet={isTablet}>
                                    {tiles.map((categoryTile, index) => {
                                        const { displayName, url, image } = categoryTile;
                                        return (
                                            <SbSharedLink
                                                className={`${styles.itemContainer} colXs3`}
                                                href={url}
                                                onClick={() => trackClick(index)}
                                                key={displayName}
                                            >
                                                <div className={styles.imageWrapper}>
                                                    <img
                                                        className={styles.image}
                                                        src={image}
                                                        alt={displayName}
                                                    />
                                                </div>
                                                <div className={styles.title}>{displayName}</div>
                                            </SbSharedLink>
                                        );
                                    })}
                                </SbRespTilesSwiper>
                            </div>
                        )}
                    </SbSharedCategoryTilesTracking>
                );
            }}
        </ServerVarsContextConsumer>
    );
};

SbRespCategoryTilesComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
};

export const SbRespCategoryTiles = createFragmentContainer(SbRespCategoryTilesComponent, {
    searchBrowse: graphql`
        fragment SbRespCategoryTiles_searchBrowse on SearchBrowseQueryConnection {
            ...SbSharedCategoryTilesTracking_searchBrowse
            categoryTiles {
                displayName
                rank
                url
                image
            }
        }
    `,
});
